import * as React from 'react';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {SidebarNav} from 'shells/sidebar-nav/sidebar-nav';

import {navItems} from './const';

import styles from './integrations-page.module.css';

type Props = ContextRouter & {
    content?: React.ReactNode;
};

export function IntegrationsPage(props: Props) {
    return (
        <div className={styles['page-container']}>
            {/* @ts-expect-error */}
            <SidebarNav navItems={navItems} />
            <div className={styles['integration-content']}>{props.content}</div>
        </div>
    );
}
